/* eslint-disable */
/* tslint:disable */

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import { FieldPolicy, FieldReadFunction, TypePolicies, TypePolicy } from '@apollo/client/cache';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** Date in ISO format (e.g. 2023-05-22) */
  Date: { input: any; output: any; }
  /** DateTime with timezone, in ISO format (e.g. 2023-05-22T15:30:00+02:00) */
  DateTime: { input: string; output: string; }
  /** JSON object */
  JSON: { input: any; output: any; }
};

export type ConfigurationActivationConfig = {
  __typename?: 'ActivationConfig';
  active: Scalars['Boolean']['output'];
  module: ConfigurationModule;
};

export type ConfigurationActivationConfigInput = {
  active: Scalars['Boolean']['input'];
  module: ConfigurationModule;
};

export type ConfigurationBrand =
  | 'BREITLING'
  | 'GALLET'
  | 'UG';

export type ConfigurationBriefCountryInfo = {
  __typename?: 'BriefCountryInfo';
  channel?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type ConfigurationChannelInfo = {
  __typename?: 'ChannelInfo';
  channel: Scalars['String']['output'];
  cmsGroup?: Maybe<Scalars['String']['output']>;
  country: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  ecommerceReady: Scalars['Boolean']['output'];
  ecsEnabled: Scalars['Boolean']['output'];
  enabled: Scalars['Boolean']['output'];
  preAuthRiskified?: Maybe<Scalars['Boolean']['output']>;
  splitShipment: Scalars['Boolean']['output'];
  trackingEnabled: Scalars['Boolean']['output'];
  warehouse?: Maybe<ConfigurationWarehouseInfo>;
};

export type ConfigurationCheckoutConfig = {
  __typename?: 'CheckoutConfig';
  affirmPaymentMax?: Maybe<Scalars['Int']['output']>;
  affirmPaymentMin?: Maybe<Scalars['Int']['output']>;
  agosPaymentMax?: Maybe<Scalars['Int']['output']>;
  agosPaymentMin?: Maybe<Scalars['Int']['output']>;
  applepayExpressPaymentMax?: Maybe<Scalars['Int']['output']>;
  applepayExpressPaymentMin?: Maybe<Scalars['Int']['output']>;
  applepayPaymentMax?: Maybe<Scalars['Int']['output']>;
  applepayPaymentMin?: Maybe<Scalars['Int']['output']>;
  bancontactPaymentMax?: Maybe<Scalars['Int']['output']>;
  bancontactPaymentMin?: Maybe<Scalars['Int']['output']>;
  bankDetails?: Maybe<Scalars['JSON']['output']>;
  brand?: Maybe<ConfigurationBrand>;
  cembraFinancingPaymentMax?: Maybe<Scalars['Int']['output']>;
  cembraFinancingPaymentMin?: Maybe<Scalars['Int']['output']>;
  cembraOpenInvoicePaymentMax?: Maybe<Scalars['Int']['output']>;
  cembraOpenInvoicePaymentMin?: Maybe<Scalars['Int']['output']>;
  channel?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  creditCardPaymentMax?: Maybe<Scalars['Int']['output']>;
  creditCardPaymentMin?: Maybe<Scalars['Int']['output']>;
  creditPlusPaymentMax?: Maybe<Scalars['Int']['output']>;
  creditPlusPaymentMin?: Maybe<Scalars['Int']['output']>;
  firstPaymentMinPercentage?: Maybe<Scalars['Int']['output']>;
  globalePaymentMax?: Maybe<Scalars['Int']['output']>;
  globalePaymentMin?: Maybe<Scalars['Int']['output']>;
  googlepayPaymentMax?: Maybe<Scalars['Int']['output']>;
  googlepayPaymentMin?: Maybe<Scalars['Int']['output']>;
  idealPaymentMax?: Maybe<Scalars['Int']['output']>;
  idealPaymentMin?: Maybe<Scalars['Int']['output']>;
  klarnaAccountFinancingPaymentMax?: Maybe<Scalars['Int']['output']>;
  klarnaAccountFinancingPaymentMin?: Maybe<Scalars['Int']['output']>;
  klarnaPayLaterPaymentMax?: Maybe<Scalars['Int']['output']>;
  klarnaPayLaterPaymentMin?: Maybe<Scalars['Int']['output']>;
  klarnaPayNowPaymentMax?: Maybe<Scalars['Int']['output']>;
  klarnaPayNowPaymentMin?: Maybe<Scalars['Int']['output']>;
  maxPayments?: Maybe<Scalars['Int']['output']>;
  minOrderAmount?: Maybe<Scalars['Int']['output']>;
  minPaymentAmount?: Maybe<Scalars['Int']['output']>;
  offlineBankTransferMinOrderAmount?: Maybe<Scalars['Int']['output']>;
  offlineBankTransferWatchRequired?: Maybe<Scalars['Boolean']['output']>;
  oney3xPaymentMax?: Maybe<Scalars['Int']['output']>;
  oney3xPaymentMin?: Maybe<Scalars['Int']['output']>;
  oney4xPaymentMax?: Maybe<Scalars['Int']['output']>;
  oney4xPaymentMin?: Maybe<Scalars['Int']['output']>;
  oricoFinancingPaymentMax?: Maybe<Scalars['Int']['output']>;
  oricoFinancingPaymentMin?: Maybe<Scalars['Int']['output']>;
  paybybankPaymentMax?: Maybe<Scalars['Int']['output']>;
  paybybankPaymentMin?: Maybe<Scalars['Int']['output']>;
  paybybankUsPaymentMax?: Maybe<Scalars['Int']['output']>;
  paybybankUsPaymentMin?: Maybe<Scalars['Int']['output']>;
  paymentLinkDuration?: Maybe<Scalars['Int']['output']>;
  paypalExpressPaymentMax?: Maybe<Scalars['Int']['output']>;
  paypalExpressPaymentMin?: Maybe<Scalars['Int']['output']>;
  paypalPaymentMax?: Maybe<Scalars['Int']['output']>;
  paypalPaymentMin?: Maybe<Scalars['Int']['output']>;
  returnPeriodDays?: Maybe<Scalars['Int']['output']>;
  smbcPaymentMax?: Maybe<Scalars['Int']['output']>;
  smbcPaymentMin?: Maybe<Scalars['Int']['output']>;
  sofortPaymentMax?: Maybe<Scalars['Int']['output']>;
  sofortPaymentMin?: Maybe<Scalars['Int']['output']>;
  twintPaymentMax?: Maybe<Scalars['Int']['output']>;
  twintPaymentMin?: Maybe<Scalars['Int']['output']>;
  v12PaymentMax?: Maybe<Scalars['Int']['output']>;
  v12PaymentMin?: Maybe<Scalars['Int']['output']>;
  yourAssetPaymentMax?: Maybe<Scalars['Int']['output']>;
  yourAssetPaymentMin?: Maybe<Scalars['Int']['output']>;
  zipPaymentMax?: Maybe<Scalars['Int']['output']>;
  zipPaymentMin?: Maybe<Scalars['Int']['output']>;
};

export type ConfigurationCheckoutConfigInput = {
  bankDetails?: InputMaybe<Scalars['JSON']['input']>;
  brand?: InputMaybe<ConfigurationBrand>;
  country: Scalars['String']['input'];
  firstPaymentMinPercentage?: InputMaybe<Scalars['Int']['input']>;
  maxPayments?: InputMaybe<Scalars['Int']['input']>;
  minOrderAmount?: InputMaybe<Scalars['Int']['input']>;
  minPaymentAmount?: InputMaybe<Scalars['Int']['input']>;
  offlineBankTransferMinOrderAmount?: InputMaybe<Scalars['Int']['input']>;
  offlineBankTransferWatchRequired?: InputMaybe<Scalars['Boolean']['input']>;
  paymentLinkDuration?: InputMaybe<Scalars['Int']['input']>;
  returnPeriodDays?: InputMaybe<Scalars['Int']['input']>;
};

export type ConfigurationCountryInfo = {
  __typename?: 'CountryInfo';
  channel?: Maybe<Scalars['String']['output']>;
  cmsGroup?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  continent: Scalars['String']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  favorite: Scalars['Boolean']['output'];
  invoiceLanguages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  languageInfos?: Maybe<Array<Maybe<ConfigurationLanguageInfo>>>;
  languages: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  region: Scalars['String']['output'];
  socialCatalogue: Scalars['Boolean']['output'];
  supported: Scalars['Boolean']['output'];
  warehouse?: Maybe<ConfigurationWarehouseInfo>;
};

export type ConfigurationCountryInfoGroupByContinent = {
  __typename?: 'CountryInfoGroupByContinent';
  continent: Scalars['String']['output'];
  countries: Array<ConfigurationBriefCountryInfo>;
};

export type ConfigurationDiscountTypeEnum =
  | 'FIXED'
  | 'PERCENTAGE';

export type ConfigurationError = {
  __typename?: 'Error';
  code: Scalars['String']['output'];
  context?: Maybe<Scalars['String']['output']>;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ConfigurationLanguageInfo = {
  __typename?: 'LanguageInfo';
  code: Scalars['String']['output'];
  contentful: Scalars['String']['output'];
  internalAlias: Scalars['String']['output'];
  locale: Scalars['String']['output'];
  name: Scalars['String']['output'];
  pim: Scalars['String']['output'];
  saleor: Scalars['String']['output'];
  sfCode: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type ConfigurationModule =
  | 'AFFIRM'
  | 'AGOS'
  | 'APPLE_PAY'
  | 'APPLE_PAY_EXPRESS'
  | 'AVAILABILITY_REQUEST'
  | 'BANCONTACT'
  | 'BANK_TRANSFER_OFFLINE_BACKOFFICE'
  | 'BANK_TRANSFER_OFFLINE_STOREFRONT'
  | 'BANK_TRANSFER_ONLINE'
  | 'BOUTIQUE_PICKUP'
  | 'BREITLING_TRADE'
  | 'CEMBRA_FINANCING'
  | 'CEMBRA_OPEN_INVOICE'
  | 'CPI_CHECK'
  | 'CREDIT_CARD'
  | 'CREDIT_PLUS'
  | 'ECS'
  | 'ENGRAVING'
  | 'E_COMMERCE'
  | 'FOR_GIFT'
  | 'FREE_RETURN'
  | 'FREE_SHIPPING'
  | 'GIFT_SERVICE'
  | 'GIFT_WITH_PURCHASE'
  | 'GOOGLE_PAY'
  | 'IDEAL'
  | 'KLARNA_ACCOUNT_FINANCING'
  | 'KLARNA_PAY_LATER'
  | 'KLARNA_PAY_NOW'
  | 'ONEY_3X'
  | 'ONEY_4X'
  | 'ORICO_FINANCING'
  | 'PAYPAL'
  | 'PAYPAL_EXPRESS'
  | 'PDP_AGOS'
  | 'PDP_CEMBRA_FINANCING'
  | 'PDP_CREDIT_PLUS'
  | 'PDP_KLARNA_PAY_LATER'
  | 'PDP_ONEY_3X'
  | 'PDP_V12'
  | 'PERSONAL_ADVISOR'
  | 'PRE_ORDER'
  | 'RISKFIED_MODE'
  | 'SECURE_PAYMENT'
  | 'SMBC'
  | 'SOCIAL_CLUB_TERMS'
  | 'SOFORT'
  | 'TWINT'
  | 'V12'
  | 'YOUR_ASSET'
  | 'ZIP';

export type ConfigurationModuleActivation = {
  __typename?: 'ModuleActivation';
  brand?: Maybe<ConfigurationBrand>;
  configs: Array<ConfigurationActivationConfig>;
  country: Scalars['String']['output'];
};

export type ConfigurationMutation = {
  __typename?: 'Mutation';
  updateCheckoutConfigs: ConfigurationUpdateCheckoutConfigsResult;
  updateModuleActivation: ConfigurationUpdateModuleActivationResult;
  updatePaymentLimitConfigs: ConfigurationUpdateCheckoutConfigsResult;
  updateVoucherConfig: ConfigurationUpdateVoucherConfigResult;
};


export type ConfigurationMutationUpdateCheckoutConfigsArgs = {
  configs: Array<ConfigurationCheckoutConfigInput>;
};


export type ConfigurationMutationUpdateModuleActivationArgs = {
  inputs: Array<ConfigurationUpdateModuleActivationInput>;
};


export type ConfigurationMutationUpdatePaymentLimitConfigsArgs = {
  configs: Array<ConfigurationPaymentLimitInput>;
};


export type ConfigurationMutationUpdateVoucherConfigArgs = {
  inputs: Array<ConfigurationUpdateVoucherConfigInput>;
};

export type ConfigurationPaymentLimitInput = {
  affirmPaymentMax?: InputMaybe<Scalars['Int']['input']>;
  affirmPaymentMin?: InputMaybe<Scalars['Int']['input']>;
  agosPaymentMax?: InputMaybe<Scalars['Int']['input']>;
  agosPaymentMin?: InputMaybe<Scalars['Int']['input']>;
  applepayExpressPaymentMax?: InputMaybe<Scalars['Int']['input']>;
  applepayExpressPaymentMin?: InputMaybe<Scalars['Int']['input']>;
  applepayPaymentMax?: InputMaybe<Scalars['Int']['input']>;
  applepayPaymentMin?: InputMaybe<Scalars['Int']['input']>;
  bancontactPaymentMax?: InputMaybe<Scalars['Int']['input']>;
  bancontactPaymentMin?: InputMaybe<Scalars['Int']['input']>;
  brand?: InputMaybe<ConfigurationBrand>;
  cembraFinancingPaymentMax?: InputMaybe<Scalars['Int']['input']>;
  cembraFinancingPaymentMin?: InputMaybe<Scalars['Int']['input']>;
  cembraOpenInvoicePaymentMax?: InputMaybe<Scalars['Int']['input']>;
  cembraOpenInvoicePaymentMin?: InputMaybe<Scalars['Int']['input']>;
  country: Scalars['String']['input'];
  creditCardPaymentMax?: InputMaybe<Scalars['Int']['input']>;
  creditCardPaymentMin?: InputMaybe<Scalars['Int']['input']>;
  creditPlusPaymentMax?: InputMaybe<Scalars['Int']['input']>;
  creditPlusPaymentMin?: InputMaybe<Scalars['Int']['input']>;
  globalePaymentMax?: InputMaybe<Scalars['Int']['input']>;
  globalePaymentMin?: InputMaybe<Scalars['Int']['input']>;
  googlepayPaymentMax?: InputMaybe<Scalars['Int']['input']>;
  googlepayPaymentMin?: InputMaybe<Scalars['Int']['input']>;
  idealPaymentMax?: InputMaybe<Scalars['Int']['input']>;
  idealPaymentMin?: InputMaybe<Scalars['Int']['input']>;
  klarnaAccountFinancingPaymentMax?: InputMaybe<Scalars['Int']['input']>;
  klarnaAccountFinancingPaymentMin?: InputMaybe<Scalars['Int']['input']>;
  klarnaPayLaterPaymentMax?: InputMaybe<Scalars['Int']['input']>;
  klarnaPayLaterPaymentMin?: InputMaybe<Scalars['Int']['input']>;
  klarnaPayNowPaymentMax?: InputMaybe<Scalars['Int']['input']>;
  klarnaPayNowPaymentMin?: InputMaybe<Scalars['Int']['input']>;
  oney3xPaymentMax?: InputMaybe<Scalars['Int']['input']>;
  oney3xPaymentMin?: InputMaybe<Scalars['Int']['input']>;
  oney4xPaymentMax?: InputMaybe<Scalars['Int']['input']>;
  oney4xPaymentMin?: InputMaybe<Scalars['Int']['input']>;
  oricoFinancingPaymentMax?: InputMaybe<Scalars['Int']['input']>;
  oricoFinancingPaymentMin?: InputMaybe<Scalars['Int']['input']>;
  paybybankPaymentMax?: InputMaybe<Scalars['Int']['input']>;
  paybybankPaymentMin?: InputMaybe<Scalars['Int']['input']>;
  paybybankUsPaymentMax?: InputMaybe<Scalars['Int']['input']>;
  paybybankUsPaymentMin?: InputMaybe<Scalars['Int']['input']>;
  paypalExpressPaymentMax?: InputMaybe<Scalars['Int']['input']>;
  paypalExpressPaymentMin?: InputMaybe<Scalars['Int']['input']>;
  paypalPaymentMax?: InputMaybe<Scalars['Int']['input']>;
  paypalPaymentMin?: InputMaybe<Scalars['Int']['input']>;
  smbcPaymentMax?: InputMaybe<Scalars['Int']['input']>;
  smbcPaymentMin?: InputMaybe<Scalars['Int']['input']>;
  sofortPaymentMax?: InputMaybe<Scalars['Int']['input']>;
  sofortPaymentMin?: InputMaybe<Scalars['Int']['input']>;
  twintPaymentMax?: InputMaybe<Scalars['Int']['input']>;
  twintPaymentMin?: InputMaybe<Scalars['Int']['input']>;
  v12PaymentMax?: InputMaybe<Scalars['Int']['input']>;
  v12PaymentMin?: InputMaybe<Scalars['Int']['input']>;
  yourAssetPaymentMax?: InputMaybe<Scalars['Int']['input']>;
  yourAssetPaymentMin?: InputMaybe<Scalars['Int']['input']>;
  zipPaymentMax?: InputMaybe<Scalars['Int']['input']>;
  zipPaymentMin?: InputMaybe<Scalars['Int']['input']>;
};

export type ConfigurationPreAuthRiskifiedChannelInfo = {
  __typename?: 'PreAuthRiskifiedChannelInfo';
  channel: Scalars['String']['output'];
  country: Scalars['String']['output'];
  preAuthRiskified: Scalars['Boolean']['output'];
};

export type ConfigurationQuery = {
  __typename?: 'Query';
  activeCampaignVouchers: Array<ConfigurationVoucherConfig>;
  channels?: Maybe<Array<Maybe<ConfigurationChannelInfo>>>;
  checkoutConfigs?: Maybe<Array<Maybe<ConfigurationCheckoutConfig>>>;
  countriesInfo?: Maybe<Array<Maybe<ConfigurationCountryInfo>>>;
  countriesInfoGroupByContinent?: Maybe<Array<Maybe<ConfigurationCountryInfoGroupByContinent>>>;
  ecsCountries?: Maybe<Array<Maybe<ConfigurationChannelInfo>>>;
  globalECountries?: Maybe<Array<Maybe<ConfigurationChannelInfo>>>;
  languages?: Maybe<Array<Maybe<ConfigurationLanguageInfo>>>;
  moduleActivations?: Maybe<Array<Maybe<ConfigurationModuleActivation>>>;
  parcelLabCountries?: Maybe<Array<Maybe<ConfigurationChannelInfo>>>;
  preAuthRiskifiedCountries?: Maybe<Array<Maybe<ConfigurationPreAuthRiskifiedChannelInfo>>>;
  supportedCountriesInfo?: Maybe<Array<Maybe<ConfigurationCountryInfo>>>;
  voucherConfig?: Maybe<ConfigurationVoucherConfig>;
  warrantyExtensionCampaigns?: Maybe<Array<Maybe<ConfigurationWarrantyExtensionCampaign>>>;
};


export type ConfigurationQueryActiveCampaignVouchersArgs = {
  brand?: InputMaybe<ConfigurationBrand>;
  channel: Scalars['String']['input'];
};


export type ConfigurationQueryChannelsArgs = {
  brand?: InputMaybe<ConfigurationBrand>;
};


export type ConfigurationQueryCheckoutConfigsArgs = {
  brand?: InputMaybe<ConfigurationBrand>;
  channels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  countries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ConfigurationQueryCountriesInfoArgs = {
  brand?: InputMaybe<ConfigurationBrand>;
  codes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ConfigurationQueryCountriesInfoGroupByContinentArgs = {
  brand?: InputMaybe<ConfigurationBrand>;
  supported?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ConfigurationQueryEcsCountriesArgs = {
  brand?: InputMaybe<ConfigurationBrand>;
};


export type ConfigurationQueryGlobalECountriesArgs = {
  brand?: InputMaybe<ConfigurationBrand>;
};


export type ConfigurationQueryLanguagesArgs = {
  brand?: InputMaybe<ConfigurationBrand>;
};


export type ConfigurationQueryModuleActivationsArgs = {
  brand?: InputMaybe<ConfigurationBrand>;
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
  modules?: InputMaybe<Array<ConfigurationModule>>;
};


export type ConfigurationQueryParcelLabCountriesArgs = {
  brand?: InputMaybe<ConfigurationBrand>;
};


export type ConfigurationQueryPreAuthRiskifiedCountriesArgs = {
  brand?: InputMaybe<ConfigurationBrand>;
};


export type ConfigurationQuerySupportedCountriesInfoArgs = {
  brand?: InputMaybe<ConfigurationBrand>;
};


export type ConfigurationQueryVoucherConfigArgs = {
  brand?: InputMaybe<ConfigurationBrand>;
  channel?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
};


export type ConfigurationQueryWarrantyExtensionCampaignsArgs = {
  brand?: InputMaybe<ConfigurationBrand>;
  countries: Array<Scalars['String']['input']>;
};

export type ConfigurationUpdateCheckoutConfigsResult = {
  __typename?: 'UpdateCheckoutConfigsResult';
  errors: Array<Maybe<ConfigurationError>>;
};

export type ConfigurationUpdateModuleActivationInput = {
  brand?: InputMaybe<ConfigurationBrand>;
  configs: Array<ConfigurationActivationConfigInput>;
  country: Scalars['String']['input'];
};

export type ConfigurationUpdateModuleActivationResult = {
  __typename?: 'UpdateModuleActivationResult';
  errors: Array<Maybe<ConfigurationError>>;
};

export type ConfigurationUpdateVoucherConfigInput = {
  applyOncePerCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  brand?: InputMaybe<ConfigurationBrand>;
  code: Scalars['String']['input'];
  country: Scalars['String']['input'];
  discount: Scalars['Int']['input'];
  discountType: ConfigurationDiscountTypeEnum;
  endDate: Scalars['DateTime']['input'];
  isPreTax?: InputMaybe<Scalars['Boolean']['input']>;
  startDate: Scalars['DateTime']['input'];
};

export type ConfigurationUpdateVoucherConfigResult = {
  __typename?: 'UpdateVoucherConfigResult';
  errors: Array<Maybe<ConfigurationError>>;
};

export type ConfigurationVoucherConfig = {
  __typename?: 'VoucherConfig';
  applyOncePerCustomer?: Maybe<Scalars['Boolean']['output']>;
  brand?: Maybe<ConfigurationBrand>;
  code: Scalars['String']['output'];
  country: Scalars['String']['output'];
  discount: Scalars['Int']['output'];
  discountType: ConfigurationDiscountTypeEnum;
  endDate: Scalars['DateTime']['output'];
  isPreTax?: Maybe<Scalars['Boolean']['output']>;
  startDate: Scalars['DateTime']['output'];
};

export type ConfigurationWarehouseInfo = {
  __typename?: 'WarehouseInfo';
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ConfigurationWarrantyExtensionCampaign = {
  __typename?: 'WarrantyExtensionCampaign';
  country: Scalars['String']['output'];
  enable: Scalars['Boolean']['output'];
  endDate?: Maybe<Scalars['Date']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
};

export type ConfigurationActiveCampaignVouchersQueryVariables = Exact<{
  channel: Scalars['String']['input'];
  brand?: InputMaybe<ConfigurationBrand>;
}>;


export type ConfigurationActiveCampaignVouchersQuery = { __typename?: 'Query', activeCampaignVouchers: Array<{ __typename?: 'VoucherConfig', code: string }> };

export type ConfigurationGetCheckoutConfigsQueryVariables = Exact<{
  countries?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type ConfigurationGetCheckoutConfigsQuery = { __typename?: 'Query', checkoutConfigs?: Array<{ __typename?: 'CheckoutConfig', country?: string | null, affirmPaymentMax?: number | null, klarnaPayNowPaymentMax?: number | null, twintPaymentMax?: number | null, channel?: string | null, v12PaymentMax?: number | null, v12PaymentMin?: number | null, cembraFinancingPaymentMax?: number | null, cembraFinancingPaymentMin?: number | null, cembraOpenInvoicePaymentMax?: number | null, cembraOpenInvoicePaymentMin?: number | null, oney3xPaymentMax?: number | null, oney3xPaymentMin?: number | null, oney4xPaymentMax?: number | null, oney4xPaymentMin?: number | null, paypalExpressPaymentMax?: number | null, paypalExpressPaymentMin?: number | null, applepayExpressPaymentMax?: number | null, applepayExpressPaymentMin?: number | null, agosPaymentMax?: number | null, agosPaymentMin?: number | null, creditPlusPaymentMax?: number | null, creditPlusPaymentMin?: number | null, zipPaymentMax?: number | null, zipPaymentMin?: number | null, smbcPaymentMax?: number | null, smbcPaymentMin?: number | null, yourAssetPaymentMin?: number | null, yourAssetPaymentMax?: number | null, returnPeriodDays?: number | null } | null> | null };

export type ConfigurationGetCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type ConfigurationGetCountriesQuery = { __typename?: 'Query', countriesInfo?: Array<{ __typename?: 'CountryInfo', code: string, name: string, region: string, continent: string, supported: boolean, favorite: boolean, languages: Array<string>, channel?: string | null, currency?: string | null } | null> | null };

export type ConfigurationGetLanguagesQueryVariables = Exact<{ [key: string]: never; }>;


export type ConfigurationGetLanguagesQuery = { __typename?: 'Query', languages?: Array<{ __typename?: 'LanguageInfo', locale: string, name: string, contentful: string, saleor: string, pim: string, sfCode: string, slug: string, code: string } | null> | null };

export type ConfigurationGetModuleActivationsQueryVariables = Exact<{
  countries?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  modules?: InputMaybe<Array<ConfigurationModule> | ConfigurationModule>;
  brand?: InputMaybe<ConfigurationBrand>;
}>;


export type ConfigurationGetModuleActivationsQuery = { __typename?: 'Query', moduleActivations?: Array<{ __typename?: 'ModuleActivation', country: string, configs: Array<{ __typename?: 'ActivationConfig', module: ConfigurationModule, active: boolean }> } | null> | null };

export type ConfigurationGetWarrantyExtensionCampaignsQueryVariables = Exact<{
  countries: Array<Scalars['String']['input']> | Scalars['String']['input'];
  brand?: InputMaybe<ConfigurationBrand>;
}>;


export type ConfigurationGetWarrantyExtensionCampaignsQuery = { __typename?: 'Query', warrantyExtensionCampaigns?: Array<{ __typename?: 'WarrantyExtensionCampaign', country: string, enable: boolean, endDate?: any | null, startDate?: any | null } | null> | null };


export const ActiveCampaignVouchersDocument = gql`
    query ActiveCampaignVouchers($channel: String!, $brand: Brand) {
  activeCampaignVouchers(channel: $channel, brand: $brand) {
    code
  }
}
    `;

/**
 * __useActiveCampaignVouchersQuery__
 *
 * To run a query within a React component, call `useActiveCampaignVouchersQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveCampaignVouchersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveCampaignVouchersQuery({
 *   variables: {
 *      channel: // value for 'channel'
 *      brand: // value for 'brand'
 *   },
 * });
 */
export function useActiveCampaignVouchersQuery(baseOptions: Apollo.QueryHookOptions<ConfigurationActiveCampaignVouchersQuery, ConfigurationActiveCampaignVouchersQueryVariables> & ({ variables: ConfigurationActiveCampaignVouchersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConfigurationActiveCampaignVouchersQuery, ConfigurationActiveCampaignVouchersQueryVariables>(ActiveCampaignVouchersDocument, options);
      }
export function useActiveCampaignVouchersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConfigurationActiveCampaignVouchersQuery, ConfigurationActiveCampaignVouchersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConfigurationActiveCampaignVouchersQuery, ConfigurationActiveCampaignVouchersQueryVariables>(ActiveCampaignVouchersDocument, options);
        }
export function useActiveCampaignVouchersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ConfigurationActiveCampaignVouchersQuery, ConfigurationActiveCampaignVouchersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ConfigurationActiveCampaignVouchersQuery, ConfigurationActiveCampaignVouchersQueryVariables>(ActiveCampaignVouchersDocument, options);
        }
export type ActiveCampaignVouchersQueryHookResult = ReturnType<typeof useActiveCampaignVouchersQuery>;
export type ActiveCampaignVouchersLazyQueryHookResult = ReturnType<typeof useActiveCampaignVouchersLazyQuery>;
export type ActiveCampaignVouchersSuspenseQueryHookResult = ReturnType<typeof useActiveCampaignVouchersSuspenseQuery>;
export type ActiveCampaignVouchersQueryResult = Apollo.QueryResult<ConfigurationActiveCampaignVouchersQuery, ConfigurationActiveCampaignVouchersQueryVariables>;
export const GetCheckoutConfigsDocument = gql`
    query getCheckoutConfigs($countries: [String!]) {
  checkoutConfigs(countries: $countries) {
    country
    affirmPaymentMax
    klarnaPayNowPaymentMax
    twintPaymentMax
    channel
    v12PaymentMax
    v12PaymentMin
    cembraFinancingPaymentMax
    cembraFinancingPaymentMin
    cembraOpenInvoicePaymentMax
    cembraOpenInvoicePaymentMin
    oney3xPaymentMax
    oney3xPaymentMin
    oney4xPaymentMax
    oney4xPaymentMin
    paypalExpressPaymentMax
    paypalExpressPaymentMin
    applepayExpressPaymentMax
    applepayExpressPaymentMin
    agosPaymentMax
    agosPaymentMin
    creditPlusPaymentMax
    creditPlusPaymentMin
    zipPaymentMax
    zipPaymentMin
    smbcPaymentMax
    smbcPaymentMin
    yourAssetPaymentMin
    yourAssetPaymentMax
    returnPeriodDays
  }
}
    `;

/**
 * __useGetCheckoutConfigsQuery__
 *
 * To run a query within a React component, call `useGetCheckoutConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCheckoutConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCheckoutConfigsQuery({
 *   variables: {
 *      countries: // value for 'countries'
 *   },
 * });
 */
export function useGetCheckoutConfigsQuery(baseOptions?: Apollo.QueryHookOptions<ConfigurationGetCheckoutConfigsQuery, ConfigurationGetCheckoutConfigsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConfigurationGetCheckoutConfigsQuery, ConfigurationGetCheckoutConfigsQueryVariables>(GetCheckoutConfigsDocument, options);
      }
export function useGetCheckoutConfigsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConfigurationGetCheckoutConfigsQuery, ConfigurationGetCheckoutConfigsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConfigurationGetCheckoutConfigsQuery, ConfigurationGetCheckoutConfigsQueryVariables>(GetCheckoutConfigsDocument, options);
        }
export function useGetCheckoutConfigsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ConfigurationGetCheckoutConfigsQuery, ConfigurationGetCheckoutConfigsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ConfigurationGetCheckoutConfigsQuery, ConfigurationGetCheckoutConfigsQueryVariables>(GetCheckoutConfigsDocument, options);
        }
export type GetCheckoutConfigsQueryHookResult = ReturnType<typeof useGetCheckoutConfigsQuery>;
export type GetCheckoutConfigsLazyQueryHookResult = ReturnType<typeof useGetCheckoutConfigsLazyQuery>;
export type GetCheckoutConfigsSuspenseQueryHookResult = ReturnType<typeof useGetCheckoutConfigsSuspenseQuery>;
export type GetCheckoutConfigsQueryResult = Apollo.QueryResult<ConfigurationGetCheckoutConfigsQuery, ConfigurationGetCheckoutConfigsQueryVariables>;
export const GetCountriesDocument = gql`
    query getCountries {
  countriesInfo {
    code
    name
    region
    continent
    supported
    favorite
    languages
    channel
    currency
  }
}
    `;

/**
 * __useGetCountriesQuery__
 *
 * To run a query within a React component, call `useGetCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCountriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCountriesQuery(baseOptions?: Apollo.QueryHookOptions<ConfigurationGetCountriesQuery, ConfigurationGetCountriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConfigurationGetCountriesQuery, ConfigurationGetCountriesQueryVariables>(GetCountriesDocument, options);
      }
export function useGetCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConfigurationGetCountriesQuery, ConfigurationGetCountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConfigurationGetCountriesQuery, ConfigurationGetCountriesQueryVariables>(GetCountriesDocument, options);
        }
export function useGetCountriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ConfigurationGetCountriesQuery, ConfigurationGetCountriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ConfigurationGetCountriesQuery, ConfigurationGetCountriesQueryVariables>(GetCountriesDocument, options);
        }
export type GetCountriesQueryHookResult = ReturnType<typeof useGetCountriesQuery>;
export type GetCountriesLazyQueryHookResult = ReturnType<typeof useGetCountriesLazyQuery>;
export type GetCountriesSuspenseQueryHookResult = ReturnType<typeof useGetCountriesSuspenseQuery>;
export type GetCountriesQueryResult = Apollo.QueryResult<ConfigurationGetCountriesQuery, ConfigurationGetCountriesQueryVariables>;
export const GetLanguagesDocument = gql`
    query getLanguages {
  languages {
    locale
    name
    contentful
    saleor
    pim
    sfCode
    slug
    code
  }
}
    `;

/**
 * __useGetLanguagesQuery__
 *
 * To run a query within a React component, call `useGetLanguagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLanguagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLanguagesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLanguagesQuery(baseOptions?: Apollo.QueryHookOptions<ConfigurationGetLanguagesQuery, ConfigurationGetLanguagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConfigurationGetLanguagesQuery, ConfigurationGetLanguagesQueryVariables>(GetLanguagesDocument, options);
      }
export function useGetLanguagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConfigurationGetLanguagesQuery, ConfigurationGetLanguagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConfigurationGetLanguagesQuery, ConfigurationGetLanguagesQueryVariables>(GetLanguagesDocument, options);
        }
export function useGetLanguagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ConfigurationGetLanguagesQuery, ConfigurationGetLanguagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ConfigurationGetLanguagesQuery, ConfigurationGetLanguagesQueryVariables>(GetLanguagesDocument, options);
        }
export type GetLanguagesQueryHookResult = ReturnType<typeof useGetLanguagesQuery>;
export type GetLanguagesLazyQueryHookResult = ReturnType<typeof useGetLanguagesLazyQuery>;
export type GetLanguagesSuspenseQueryHookResult = ReturnType<typeof useGetLanguagesSuspenseQuery>;
export type GetLanguagesQueryResult = Apollo.QueryResult<ConfigurationGetLanguagesQuery, ConfigurationGetLanguagesQueryVariables>;
export const GetModuleActivationsDocument = gql`
    query getModuleActivations($countries: [String!], $modules: [Module!], $brand: Brand) {
  moduleActivations(countries: $countries, modules: $modules, brand: $brand) {
    country
    configs {
      module
      active
    }
  }
}
    `;

/**
 * __useGetModuleActivationsQuery__
 *
 * To run a query within a React component, call `useGetModuleActivationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetModuleActivationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetModuleActivationsQuery({
 *   variables: {
 *      countries: // value for 'countries'
 *      modules: // value for 'modules'
 *      brand: // value for 'brand'
 *   },
 * });
 */
export function useGetModuleActivationsQuery(baseOptions?: Apollo.QueryHookOptions<ConfigurationGetModuleActivationsQuery, ConfigurationGetModuleActivationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConfigurationGetModuleActivationsQuery, ConfigurationGetModuleActivationsQueryVariables>(GetModuleActivationsDocument, options);
      }
export function useGetModuleActivationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConfigurationGetModuleActivationsQuery, ConfigurationGetModuleActivationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConfigurationGetModuleActivationsQuery, ConfigurationGetModuleActivationsQueryVariables>(GetModuleActivationsDocument, options);
        }
export function useGetModuleActivationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ConfigurationGetModuleActivationsQuery, ConfigurationGetModuleActivationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ConfigurationGetModuleActivationsQuery, ConfigurationGetModuleActivationsQueryVariables>(GetModuleActivationsDocument, options);
        }
export type GetModuleActivationsQueryHookResult = ReturnType<typeof useGetModuleActivationsQuery>;
export type GetModuleActivationsLazyQueryHookResult = ReturnType<typeof useGetModuleActivationsLazyQuery>;
export type GetModuleActivationsSuspenseQueryHookResult = ReturnType<typeof useGetModuleActivationsSuspenseQuery>;
export type GetModuleActivationsQueryResult = Apollo.QueryResult<ConfigurationGetModuleActivationsQuery, ConfigurationGetModuleActivationsQueryVariables>;
export const GetWarrantyExtensionCampaignsDocument = gql`
    query getWarrantyExtensionCampaigns($countries: [String!]!, $brand: Brand) {
  warrantyExtensionCampaigns(countries: $countries, brand: $brand) {
    country
    enable
    endDate
    startDate
  }
}
    `;

/**
 * __useGetWarrantyExtensionCampaignsQuery__
 *
 * To run a query within a React component, call `useGetWarrantyExtensionCampaignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWarrantyExtensionCampaignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWarrantyExtensionCampaignsQuery({
 *   variables: {
 *      countries: // value for 'countries'
 *      brand: // value for 'brand'
 *   },
 * });
 */
export function useGetWarrantyExtensionCampaignsQuery(baseOptions: Apollo.QueryHookOptions<ConfigurationGetWarrantyExtensionCampaignsQuery, ConfigurationGetWarrantyExtensionCampaignsQueryVariables> & ({ variables: ConfigurationGetWarrantyExtensionCampaignsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConfigurationGetWarrantyExtensionCampaignsQuery, ConfigurationGetWarrantyExtensionCampaignsQueryVariables>(GetWarrantyExtensionCampaignsDocument, options);
      }
export function useGetWarrantyExtensionCampaignsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConfigurationGetWarrantyExtensionCampaignsQuery, ConfigurationGetWarrantyExtensionCampaignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConfigurationGetWarrantyExtensionCampaignsQuery, ConfigurationGetWarrantyExtensionCampaignsQueryVariables>(GetWarrantyExtensionCampaignsDocument, options);
        }
export function useGetWarrantyExtensionCampaignsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ConfigurationGetWarrantyExtensionCampaignsQuery, ConfigurationGetWarrantyExtensionCampaignsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ConfigurationGetWarrantyExtensionCampaignsQuery, ConfigurationGetWarrantyExtensionCampaignsQueryVariables>(GetWarrantyExtensionCampaignsDocument, options);
        }
export type GetWarrantyExtensionCampaignsQueryHookResult = ReturnType<typeof useGetWarrantyExtensionCampaignsQuery>;
export type GetWarrantyExtensionCampaignsLazyQueryHookResult = ReturnType<typeof useGetWarrantyExtensionCampaignsLazyQuery>;
export type GetWarrantyExtensionCampaignsSuspenseQueryHookResult = ReturnType<typeof useGetWarrantyExtensionCampaignsSuspenseQuery>;
export type GetWarrantyExtensionCampaignsQueryResult = Apollo.QueryResult<ConfigurationGetWarrantyExtensionCampaignsQuery, ConfigurationGetWarrantyExtensionCampaignsQueryVariables>;
export type ActivationConfigKeySpecifier = ('active' | 'module' | ActivationConfigKeySpecifier)[];
export type ActivationConfigFieldPolicy = {
	active?: FieldPolicy<any> | FieldReadFunction<any>,
	module?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BriefCountryInfoKeySpecifier = ('channel' | 'code' | 'currency' | 'name' | BriefCountryInfoKeySpecifier)[];
export type BriefCountryInfoFieldPolicy = {
	channel?: FieldPolicy<any> | FieldReadFunction<any>,
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	currency?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ChannelInfoKeySpecifier = ('channel' | 'cmsGroup' | 'country' | 'currency' | 'ecommerceReady' | 'ecsEnabled' | 'enabled' | 'preAuthRiskified' | 'splitShipment' | 'trackingEnabled' | 'warehouse' | ChannelInfoKeySpecifier)[];
export type ChannelInfoFieldPolicy = {
	channel?: FieldPolicy<any> | FieldReadFunction<any>,
	cmsGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	currency?: FieldPolicy<any> | FieldReadFunction<any>,
	ecommerceReady?: FieldPolicy<any> | FieldReadFunction<any>,
	ecsEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	enabled?: FieldPolicy<any> | FieldReadFunction<any>,
	preAuthRiskified?: FieldPolicy<any> | FieldReadFunction<any>,
	splitShipment?: FieldPolicy<any> | FieldReadFunction<any>,
	trackingEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	warehouse?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CheckoutConfigKeySpecifier = ('affirmPaymentMax' | 'affirmPaymentMin' | 'agosPaymentMax' | 'agosPaymentMin' | 'applepayExpressPaymentMax' | 'applepayExpressPaymentMin' | 'applepayPaymentMax' | 'applepayPaymentMin' | 'bancontactPaymentMax' | 'bancontactPaymentMin' | 'bankDetails' | 'brand' | 'cembraFinancingPaymentMax' | 'cembraFinancingPaymentMin' | 'cembraOpenInvoicePaymentMax' | 'cembraOpenInvoicePaymentMin' | 'channel' | 'country' | 'creditCardPaymentMax' | 'creditCardPaymentMin' | 'creditPlusPaymentMax' | 'creditPlusPaymentMin' | 'firstPaymentMinPercentage' | 'globalePaymentMax' | 'globalePaymentMin' | 'googlepayPaymentMax' | 'googlepayPaymentMin' | 'idealPaymentMax' | 'idealPaymentMin' | 'klarnaAccountFinancingPaymentMax' | 'klarnaAccountFinancingPaymentMin' | 'klarnaPayLaterPaymentMax' | 'klarnaPayLaterPaymentMin' | 'klarnaPayNowPaymentMax' | 'klarnaPayNowPaymentMin' | 'maxPayments' | 'minOrderAmount' | 'minPaymentAmount' | 'offlineBankTransferMinOrderAmount' | 'offlineBankTransferWatchRequired' | 'oney3xPaymentMax' | 'oney3xPaymentMin' | 'oney4xPaymentMax' | 'oney4xPaymentMin' | 'oricoFinancingPaymentMax' | 'oricoFinancingPaymentMin' | 'paybybankPaymentMax' | 'paybybankPaymentMin' | 'paybybankUsPaymentMax' | 'paybybankUsPaymentMin' | 'paymentLinkDuration' | 'paypalExpressPaymentMax' | 'paypalExpressPaymentMin' | 'paypalPaymentMax' | 'paypalPaymentMin' | 'returnPeriodDays' | 'smbcPaymentMax' | 'smbcPaymentMin' | 'sofortPaymentMax' | 'sofortPaymentMin' | 'twintPaymentMax' | 'twintPaymentMin' | 'v12PaymentMax' | 'v12PaymentMin' | 'yourAssetPaymentMax' | 'yourAssetPaymentMin' | 'zipPaymentMax' | 'zipPaymentMin' | CheckoutConfigKeySpecifier)[];
export type CheckoutConfigFieldPolicy = {
	affirmPaymentMax?: FieldPolicy<any> | FieldReadFunction<any>,
	affirmPaymentMin?: FieldPolicy<any> | FieldReadFunction<any>,
	agosPaymentMax?: FieldPolicy<any> | FieldReadFunction<any>,
	agosPaymentMin?: FieldPolicy<any> | FieldReadFunction<any>,
	applepayExpressPaymentMax?: FieldPolicy<any> | FieldReadFunction<any>,
	applepayExpressPaymentMin?: FieldPolicy<any> | FieldReadFunction<any>,
	applepayPaymentMax?: FieldPolicy<any> | FieldReadFunction<any>,
	applepayPaymentMin?: FieldPolicy<any> | FieldReadFunction<any>,
	bancontactPaymentMax?: FieldPolicy<any> | FieldReadFunction<any>,
	bancontactPaymentMin?: FieldPolicy<any> | FieldReadFunction<any>,
	bankDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	brand?: FieldPolicy<any> | FieldReadFunction<any>,
	cembraFinancingPaymentMax?: FieldPolicy<any> | FieldReadFunction<any>,
	cembraFinancingPaymentMin?: FieldPolicy<any> | FieldReadFunction<any>,
	cembraOpenInvoicePaymentMax?: FieldPolicy<any> | FieldReadFunction<any>,
	cembraOpenInvoicePaymentMin?: FieldPolicy<any> | FieldReadFunction<any>,
	channel?: FieldPolicy<any> | FieldReadFunction<any>,
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	creditCardPaymentMax?: FieldPolicy<any> | FieldReadFunction<any>,
	creditCardPaymentMin?: FieldPolicy<any> | FieldReadFunction<any>,
	creditPlusPaymentMax?: FieldPolicy<any> | FieldReadFunction<any>,
	creditPlusPaymentMin?: FieldPolicy<any> | FieldReadFunction<any>,
	firstPaymentMinPercentage?: FieldPolicy<any> | FieldReadFunction<any>,
	globalePaymentMax?: FieldPolicy<any> | FieldReadFunction<any>,
	globalePaymentMin?: FieldPolicy<any> | FieldReadFunction<any>,
	googlepayPaymentMax?: FieldPolicy<any> | FieldReadFunction<any>,
	googlepayPaymentMin?: FieldPolicy<any> | FieldReadFunction<any>,
	idealPaymentMax?: FieldPolicy<any> | FieldReadFunction<any>,
	idealPaymentMin?: FieldPolicy<any> | FieldReadFunction<any>,
	klarnaAccountFinancingPaymentMax?: FieldPolicy<any> | FieldReadFunction<any>,
	klarnaAccountFinancingPaymentMin?: FieldPolicy<any> | FieldReadFunction<any>,
	klarnaPayLaterPaymentMax?: FieldPolicy<any> | FieldReadFunction<any>,
	klarnaPayLaterPaymentMin?: FieldPolicy<any> | FieldReadFunction<any>,
	klarnaPayNowPaymentMax?: FieldPolicy<any> | FieldReadFunction<any>,
	klarnaPayNowPaymentMin?: FieldPolicy<any> | FieldReadFunction<any>,
	maxPayments?: FieldPolicy<any> | FieldReadFunction<any>,
	minOrderAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	minPaymentAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	offlineBankTransferMinOrderAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	offlineBankTransferWatchRequired?: FieldPolicy<any> | FieldReadFunction<any>,
	oney3xPaymentMax?: FieldPolicy<any> | FieldReadFunction<any>,
	oney3xPaymentMin?: FieldPolicy<any> | FieldReadFunction<any>,
	oney4xPaymentMax?: FieldPolicy<any> | FieldReadFunction<any>,
	oney4xPaymentMin?: FieldPolicy<any> | FieldReadFunction<any>,
	oricoFinancingPaymentMax?: FieldPolicy<any> | FieldReadFunction<any>,
	oricoFinancingPaymentMin?: FieldPolicy<any> | FieldReadFunction<any>,
	paybybankPaymentMax?: FieldPolicy<any> | FieldReadFunction<any>,
	paybybankPaymentMin?: FieldPolicy<any> | FieldReadFunction<any>,
	paybybankUsPaymentMax?: FieldPolicy<any> | FieldReadFunction<any>,
	paybybankUsPaymentMin?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentLinkDuration?: FieldPolicy<any> | FieldReadFunction<any>,
	paypalExpressPaymentMax?: FieldPolicy<any> | FieldReadFunction<any>,
	paypalExpressPaymentMin?: FieldPolicy<any> | FieldReadFunction<any>,
	paypalPaymentMax?: FieldPolicy<any> | FieldReadFunction<any>,
	paypalPaymentMin?: FieldPolicy<any> | FieldReadFunction<any>,
	returnPeriodDays?: FieldPolicy<any> | FieldReadFunction<any>,
	smbcPaymentMax?: FieldPolicy<any> | FieldReadFunction<any>,
	smbcPaymentMin?: FieldPolicy<any> | FieldReadFunction<any>,
	sofortPaymentMax?: FieldPolicy<any> | FieldReadFunction<any>,
	sofortPaymentMin?: FieldPolicy<any> | FieldReadFunction<any>,
	twintPaymentMax?: FieldPolicy<any> | FieldReadFunction<any>,
	twintPaymentMin?: FieldPolicy<any> | FieldReadFunction<any>,
	v12PaymentMax?: FieldPolicy<any> | FieldReadFunction<any>,
	v12PaymentMin?: FieldPolicy<any> | FieldReadFunction<any>,
	yourAssetPaymentMax?: FieldPolicy<any> | FieldReadFunction<any>,
	yourAssetPaymentMin?: FieldPolicy<any> | FieldReadFunction<any>,
	zipPaymentMax?: FieldPolicy<any> | FieldReadFunction<any>,
	zipPaymentMin?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CountryInfoKeySpecifier = ('channel' | 'cmsGroup' | 'code' | 'continent' | 'currency' | 'favorite' | 'invoiceLanguages' | 'languageInfos' | 'languages' | 'name' | 'region' | 'socialCatalogue' | 'supported' | 'warehouse' | CountryInfoKeySpecifier)[];
export type CountryInfoFieldPolicy = {
	channel?: FieldPolicy<any> | FieldReadFunction<any>,
	cmsGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	continent?: FieldPolicy<any> | FieldReadFunction<any>,
	currency?: FieldPolicy<any> | FieldReadFunction<any>,
	favorite?: FieldPolicy<any> | FieldReadFunction<any>,
	invoiceLanguages?: FieldPolicy<any> | FieldReadFunction<any>,
	languageInfos?: FieldPolicy<any> | FieldReadFunction<any>,
	languages?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	region?: FieldPolicy<any> | FieldReadFunction<any>,
	socialCatalogue?: FieldPolicy<any> | FieldReadFunction<any>,
	supported?: FieldPolicy<any> | FieldReadFunction<any>,
	warehouse?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CountryInfoGroupByContinentKeySpecifier = ('continent' | 'countries' | CountryInfoGroupByContinentKeySpecifier)[];
export type CountryInfoGroupByContinentFieldPolicy = {
	continent?: FieldPolicy<any> | FieldReadFunction<any>,
	countries?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ErrorKeySpecifier = ('code' | 'context' | 'field' | 'message' | ErrorKeySpecifier)[];
export type ErrorFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	context?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LanguageInfoKeySpecifier = ('code' | 'contentful' | 'internalAlias' | 'locale' | 'name' | 'pim' | 'saleor' | 'sfCode' | 'slug' | LanguageInfoKeySpecifier)[];
export type LanguageInfoFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	contentful?: FieldPolicy<any> | FieldReadFunction<any>,
	internalAlias?: FieldPolicy<any> | FieldReadFunction<any>,
	locale?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	pim?: FieldPolicy<any> | FieldReadFunction<any>,
	saleor?: FieldPolicy<any> | FieldReadFunction<any>,
	sfCode?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ModuleActivationKeySpecifier = ('brand' | 'configs' | 'country' | ModuleActivationKeySpecifier)[];
export type ModuleActivationFieldPolicy = {
	brand?: FieldPolicy<any> | FieldReadFunction<any>,
	configs?: FieldPolicy<any> | FieldReadFunction<any>,
	country?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MutationKeySpecifier = ('updateCheckoutConfigs' | 'updateModuleActivation' | 'updatePaymentLimitConfigs' | 'updateVoucherConfig' | MutationKeySpecifier)[];
export type MutationFieldPolicy = {
	updateCheckoutConfigs?: FieldPolicy<any> | FieldReadFunction<any>,
	updateModuleActivation?: FieldPolicy<any> | FieldReadFunction<any>,
	updatePaymentLimitConfigs?: FieldPolicy<any> | FieldReadFunction<any>,
	updateVoucherConfig?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PreAuthRiskifiedChannelInfoKeySpecifier = ('channel' | 'country' | 'preAuthRiskified' | PreAuthRiskifiedChannelInfoKeySpecifier)[];
export type PreAuthRiskifiedChannelInfoFieldPolicy = {
	channel?: FieldPolicy<any> | FieldReadFunction<any>,
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	preAuthRiskified?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QueryKeySpecifier = ('activeCampaignVouchers' | 'channels' | 'checkoutConfigs' | 'countriesInfo' | 'countriesInfoGroupByContinent' | 'ecsCountries' | 'globalECountries' | 'languages' | 'moduleActivations' | 'parcelLabCountries' | 'preAuthRiskifiedCountries' | 'supportedCountriesInfo' | 'voucherConfig' | 'warrantyExtensionCampaigns' | QueryKeySpecifier)[];
export type QueryFieldPolicy = {
	activeCampaignVouchers?: FieldPolicy<any> | FieldReadFunction<any>,
	channels?: FieldPolicy<any> | FieldReadFunction<any>,
	checkoutConfigs?: FieldPolicy<any> | FieldReadFunction<any>,
	countriesInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	countriesInfoGroupByContinent?: FieldPolicy<any> | FieldReadFunction<any>,
	ecsCountries?: FieldPolicy<any> | FieldReadFunction<any>,
	globalECountries?: FieldPolicy<any> | FieldReadFunction<any>,
	languages?: FieldPolicy<any> | FieldReadFunction<any>,
	moduleActivations?: FieldPolicy<any> | FieldReadFunction<any>,
	parcelLabCountries?: FieldPolicy<any> | FieldReadFunction<any>,
	preAuthRiskifiedCountries?: FieldPolicy<any> | FieldReadFunction<any>,
	supportedCountriesInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	voucherConfig?: FieldPolicy<any> | FieldReadFunction<any>,
	warrantyExtensionCampaigns?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateCheckoutConfigsResultKeySpecifier = ('errors' | UpdateCheckoutConfigsResultKeySpecifier)[];
export type UpdateCheckoutConfigsResultFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateModuleActivationResultKeySpecifier = ('errors' | UpdateModuleActivationResultKeySpecifier)[];
export type UpdateModuleActivationResultFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateVoucherConfigResultKeySpecifier = ('errors' | UpdateVoucherConfigResultKeySpecifier)[];
export type UpdateVoucherConfigResultFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VoucherConfigKeySpecifier = ('applyOncePerCustomer' | 'brand' | 'code' | 'country' | 'discount' | 'discountType' | 'endDate' | 'isPreTax' | 'startDate' | VoucherConfigKeySpecifier)[];
export type VoucherConfigFieldPolicy = {
	applyOncePerCustomer?: FieldPolicy<any> | FieldReadFunction<any>,
	brand?: FieldPolicy<any> | FieldReadFunction<any>,
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	discount?: FieldPolicy<any> | FieldReadFunction<any>,
	discountType?: FieldPolicy<any> | FieldReadFunction<any>,
	endDate?: FieldPolicy<any> | FieldReadFunction<any>,
	isPreTax?: FieldPolicy<any> | FieldReadFunction<any>,
	startDate?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WarehouseInfoKeySpecifier = ('code' | 'name' | WarehouseInfoKeySpecifier)[];
export type WarehouseInfoFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WarrantyExtensionCampaignKeySpecifier = ('country' | 'enable' | 'endDate' | 'startDate' | WarrantyExtensionCampaignKeySpecifier)[];
export type WarrantyExtensionCampaignFieldPolicy = {
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	enable?: FieldPolicy<any> | FieldReadFunction<any>,
	endDate?: FieldPolicy<any> | FieldReadFunction<any>,
	startDate?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StrictTypedTypePolicies = {
	ActivationConfig?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ActivationConfigKeySpecifier | (() => undefined | ActivationConfigKeySpecifier),
		fields?: ActivationConfigFieldPolicy,
	},
	BriefCountryInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BriefCountryInfoKeySpecifier | (() => undefined | BriefCountryInfoKeySpecifier),
		fields?: BriefCountryInfoFieldPolicy,
	},
	ChannelInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ChannelInfoKeySpecifier | (() => undefined | ChannelInfoKeySpecifier),
		fields?: ChannelInfoFieldPolicy,
	},
	CheckoutConfig?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CheckoutConfigKeySpecifier | (() => undefined | CheckoutConfigKeySpecifier),
		fields?: CheckoutConfigFieldPolicy,
	},
	CountryInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CountryInfoKeySpecifier | (() => undefined | CountryInfoKeySpecifier),
		fields?: CountryInfoFieldPolicy,
	},
	CountryInfoGroupByContinent?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CountryInfoGroupByContinentKeySpecifier | (() => undefined | CountryInfoGroupByContinentKeySpecifier),
		fields?: CountryInfoGroupByContinentFieldPolicy,
	},
	Error?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ErrorKeySpecifier | (() => undefined | ErrorKeySpecifier),
		fields?: ErrorFieldPolicy,
	},
	LanguageInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LanguageInfoKeySpecifier | (() => undefined | LanguageInfoKeySpecifier),
		fields?: LanguageInfoFieldPolicy,
	},
	ModuleActivation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ModuleActivationKeySpecifier | (() => undefined | ModuleActivationKeySpecifier),
		fields?: ModuleActivationFieldPolicy,
	},
	Mutation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MutationKeySpecifier | (() => undefined | MutationKeySpecifier),
		fields?: MutationFieldPolicy,
	},
	PreAuthRiskifiedChannelInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PreAuthRiskifiedChannelInfoKeySpecifier | (() => undefined | PreAuthRiskifiedChannelInfoKeySpecifier),
		fields?: PreAuthRiskifiedChannelInfoFieldPolicy,
	},
	Query?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QueryKeySpecifier | (() => undefined | QueryKeySpecifier),
		fields?: QueryFieldPolicy,
	},
	UpdateCheckoutConfigsResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateCheckoutConfigsResultKeySpecifier | (() => undefined | UpdateCheckoutConfigsResultKeySpecifier),
		fields?: UpdateCheckoutConfigsResultFieldPolicy,
	},
	UpdateModuleActivationResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateModuleActivationResultKeySpecifier | (() => undefined | UpdateModuleActivationResultKeySpecifier),
		fields?: UpdateModuleActivationResultFieldPolicy,
	},
	UpdateVoucherConfigResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateVoucherConfigResultKeySpecifier | (() => undefined | UpdateVoucherConfigResultKeySpecifier),
		fields?: UpdateVoucherConfigResultFieldPolicy,
	},
	VoucherConfig?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VoucherConfigKeySpecifier | (() => undefined | VoucherConfigKeySpecifier),
		fields?: VoucherConfigFieldPolicy,
	},
	WarehouseInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WarehouseInfoKeySpecifier | (() => undefined | WarehouseInfoKeySpecifier),
		fields?: WarehouseInfoFieldPolicy,
	},
	WarrantyExtensionCampaign?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WarrantyExtensionCampaignKeySpecifier | (() => undefined | WarrantyExtensionCampaignKeySpecifier),
		fields?: WarrantyExtensionCampaignFieldPolicy,
	}
};
export type TypedTypePolicies = StrictTypedTypePolicies & TypePolicies;

export type ConfigurationGetCheckoutBootstrapQueryVariables = {
  brand?: ConfigurationBrand | null;
  countries: Array<string>;
  modules?: Array<ConfigurationModule> | null;
};

export type ConfigurationGetCheckoutBootstrapQuery = {
  __typename?: 'Query';
  checkoutConfigs?: ConfigurationGetCheckoutConfigsQuery['checkoutConfigs'];
  moduleActivations?: ConfigurationGetModuleActivationsQuery['moduleActivations'];
  warrantyExtensionCampaigns?: ConfigurationGetWarrantyExtensionCampaignsQuery['warrantyExtensionCampaigns'];
};

export const GetCheckoutBootstrapDocument = gql`
  query getCheckoutBootstrap(
    $countries: [String!]!
    $modules: [Module!]
    $brand: Brand
  ) {
    checkoutConfigs(countries: $countries) {
      country
      affirmPaymentMax
      klarnaPayNowPaymentMax
      twintPaymentMax
      channel
      v12PaymentMax
      v12PaymentMin
      cembraFinancingPaymentMax
      cembraFinancingPaymentMin
      cembraOpenInvoicePaymentMax
      cembraOpenInvoicePaymentMin
      oney3xPaymentMax
      oney3xPaymentMin
      oney4xPaymentMax
      oney4xPaymentMin
      paypalExpressPaymentMax
      paypalExpressPaymentMin
      applepayExpressPaymentMax
      applepayExpressPaymentMin
      agosPaymentMax
      agosPaymentMin
      creditPlusPaymentMax
      creditPlusPaymentMin
      zipPaymentMax
      zipPaymentMin
      smbcPaymentMax
      smbcPaymentMin
      yourAssetPaymentMin
      yourAssetPaymentMax
      returnPeriodDays
    }
    moduleActivations(countries: $countries, modules: $modules, brand: $brand) {
      country
      configs {
        module
        active
      }
    }
    warrantyExtensionCampaigns(countries: $countries, brand: $brand) {
      country
      enable
      endDate
      startDate
    }
  }
`;
